module.exports = __webpack_public_path__ + "img/70.2ca01e1e.jpg";